import React, { useEffect, useState } from "react";
import "../styles/edit-preference-popup.scss";
import { useSelector } from "react-redux";
import { GuiButton } from "../components/global-ui/gui-button";
import { useUpdateState } from "../utilities/utilities";
import { GuiCheckbox } from "../components/global-ui/gui-checkbox";
import { GuiTextbox } from "../components/global-ui/gui-textbox";
import VoiceDropdown from "../components/voice-dropdown";
import { SettingsApi } from "../actions/settings-action";
import AudioPlayer from "../components/audio-player";
import CircularProgress from "../actions/CircularProgress";
import user from "../actions/user-actions";
import { showToast } from "../components/toast";
import { UserRole } from "../utilities/constants";

const EditPreferencePopup = ({
  userId,
  isEditPreference,
  onClose,
  onSucessfullAdd,
  preferenceValue,
}) => {
  let [state, updateState] = useUpdateState(() => {
    return {
      isUpdateDisabled: false,
      enableEmail: false,
      email: "",
      typeOptions: [],
      optionType: null,
      selectedVoiceId: 28,
      loading: false,
      fileUrl: null,
      isAudioLoading: true,
      replyToEmail: "",
      phoneCode: "",
      phonePin: "",
    };
  });
  let isMobile = useSelector((store) => store.page.isMobile);
  const person = JSON.parse(localStorage.getItem("selectedPerson"));
  let loginUser = useSelector((store) => store.user);
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  useEffect(() => {
    voiceOptions();
  }, []);

  const [fieldErrors, setFieldErrors] = useState({
    email: false,
    replyToEmail: false,
  });
  async function voiceOptions() {
    let response = await SettingsApi.getVoiceOptions().then((result) => {
      const typeOptions = [
        { label: result.voices[1].voiceOption, value: result.voices[1].id },
        { label: result.voices[0].voiceOption, value: result.voices[0].id },
        { label: result.voices[2].voiceOption, value: result.voices[2].id },
        { label: result.voices[3].voiceOption, value: result.voices[3].id },
        { label: result.voices[4].voiceOption, value: result.voices[4].id },
      ];
      updateState({
        typeOptions: typeOptions,
      });
      updateState({ optionType: result.voices[1].id });
      if (preferenceValue && Object.keys(preferenceValue).length > 0) {
        const selectedVoiceId = typeOptions.find(
          (items) => items.label === preferenceValue.selectedVoiceId,
        )?.value;

        updateState({ loading: true });
        updateState({
          enableEmail: preferenceValue.enableEmail,
          email: preferenceValue.email,
          replyToEmail: preferenceValue.replyToEmail,
          selectedVoiceId: selectedVoiceId,
          optionType: selectedVoiceId,
          phoneCode: preferenceValue.phoneCode,
          phonePin: preferenceValue.phonePin,
        });
        sampleFile(selectedVoiceId);
      } else {
        sampleFile(state.selectedVoiceId);
      }
    });
  }
  function validateEmail() {
    let isValid = true;
    const errors = {};

    // Validate email field
    if (state.email !== "") {
      if (!emailRegex.test(state.email)) {
        errors.email = true;
        isValid = false;
      }
    }

    // Validate replyToEmail field
    if (state.replyToEmail !== "" && state.replyToEmail != null) {
      if (!emailRegex.test(state.replyToEmail)) {
        errors.replyToEmail = true;
        isValid = false;
      }
    }

    // Update field errors if there are any
    if (!isValid) {
      setFieldErrors((prevErrors) => ({
        ...prevErrors,
        ...errors,
      }));
    } else {
      // Clear any existing errors if validation passes
      setFieldErrors((prevErrors) => ({
        ...prevErrors,
        email: false,
        replyToEmail: false,
      }));
    }

    return isValid;
  }
  const onUpdate = async () => {
    if (state.enableEmail) {
      if (!validateEmail()) {
        return;
      }
    }

    updateState({ isUpdateDisabled: true });
    let payload = {
      VoiceId: state?.selectedVoiceId,
      SmsEnableNotify: state?.enableEmail,
      SmsNotifyEmail: state?.email,
      ReplyToEmail: state?.replyToEmail,
      phoneCode: state?.phoneCode,
      phonePin: state?.phonePin,
    };

    if (userId) {
      let result = await user.updatePreferenceForSpecificUser(payload, userId);
      if (result.success) {
        updateState({ isUpdateDisabled: false });
        showToast("success", "Preferences updated successfully");
        onClose();
        onSucessfullAdd();
      }
    } else {
      let result = await user.updatePreference(payload);
      if (result.success) {
        updateState({ isUpdateDisabled: false });
        showToast("success", "Preferences updated successfully");
        onClose();
        onSucessfullAdd();
      }
    }
  };
  const onFilterChange = (name, value) => {
    updateState({ isAudioLoading: true });
    updateState({ [name]: value });
    updateState({ selectedVoiceId: value });
    sampleFile(value);
  };
  const handleChange = (name, value) => {
    if (name === "enableEmail") {
      !value && updateState({ email: "", replyToEmail: "" });
      // Clear errors when email is disabled
      if (!value) {
        setFieldErrors((prevErrors) => ({
          ...prevErrors,
          email: false,
          replyToEmail: false,
        }));
      }
    }

    // Clear specific field error when field is cleared
    if ((name === "email" || name === "replyToEmail") && value === "") {
      setFieldErrors((prevErrors) => ({
        ...prevErrors,
        [name]: false,
      }));
    }

    updateState(name, value);
  };
  async function sampleFile(selectedVoiceId) {
    let result = await SettingsApi.sampleFile({
      id: selectedVoiceId,
    });
    if (result) {
      updateState({ fileUrl: result.fileUrl });
      updateState({ isAudioLoading: false });
    } else {
      updateState({ fileUrl: null });
    }
  }

  return (
    <div
      className={`edit-preference Modal ${isEditPreference ? "Show" : "hide"}`}
    >
      <>
        <div className="modal-header">
          {isMobile && (
            <span onClick={onClose} className="mr-2">
              <i className="fa fa-chevron-left close-primary-icon cursor-pointer"></i>
            </span>
          )}
          <h4>Edit Preferences</h4>
          {!isMobile && (
            <span onClick={onClose}>
              <i className="fa fa-close close-primary-icon cursor-pointer"></i>
            </span>
          )}
        </div>
        <div className="modal-body">
          <span className="text-base-primary">Text Notification Email</span>
          <div className="email-checkbox">
            <div className="checkbox-row">
              <GuiCheckbox
                label="Notify me when I get a text response"
                name="enableEmail"
                value={state?.enableEmail}
                onChange={handleChange}
              />
            </div>
          </div>
          {state?.enableEmail && (
            <>
              <div className="email-field">
                <div className="email-field-row">
                  <GuiTextbox
                    label="Text Notification Email"
                    name="email"
                    className={`email ${
                      fieldErrors.email && "has-email-error"
                    }`}
                    value={state.email}
                    onChange={handleChange}
                    maxLength={100}
                    error={
                      fieldErrors.email && (
                        <span>
                          <i className="fas fa-exclamation-circle"></i> Invalid
                          Email Address
                        </span>
                      )
                    }
                  />
                </div>
                <span className="helper-text">
                  Leave this blank to use your primary email address
                </span>
              </div>
            </>
          )}

          {/* Reply to email notification */}
          {((userId && person.userTypeId === UserRole.Admin) ||
            (!userId && loginUser?.userType === UserRole.Admin)) && (
            <>
              <span className="text-base-primary">Reply to Email</span>
              <div className="email-field">
                <div className="email-field-row">
                  <GuiTextbox
                    label="Reply to Email"
                    name="replyToEmail"
                    className={`email ${
                      fieldErrors.replyToEmail && "has-email-error"
                    }`}
                    value={state.replyToEmail}
                    onChange={handleChange}
                    maxLength={100}
                    error={
                      fieldErrors.replyToEmail && (
                        <span>
                          <i className="fas fa-exclamation-circle"></i> Invalid
                          Email Address
                        </span>
                      )
                    }
                  />
                </div>
              </div>
            </>
          )}
          <div className="voice-preference">
            <h4>Voice Preference</h4>
            <div className="voice-preference-dropdown">
              {state.loading && (
                <>
                  <VoiceDropdown
                    onChange={onFilterChange}
                    optionType={state.optionType}
                    typeOptions={state.typeOptions}
                  />
                  <span>
                    The voice your text-to-speech messages will sound like
                  </span>
                </>
              )}
            </div>
            <div className="voice-sample">
              <span>Voice Sample</span>
              {state.isAudioLoading ? (
                <CircularProgress />
              ) : (
                <AudioPlayer src={state.fileUrl} autoPlay={false} />
              )}
            </div>
            {/* Phone code and pin */}
            <div>
              {/* <span className="text-base-primary">Phone Code</span> */}
              <div className="email-field">
                <div className="email-field-row">
                  <GuiTextbox
                    label="Phone Code"
                    name="phoneCode"
                    value={state.phoneCode}
                    onChange={handleChange}
                    maxLength={50}
                  />
                </div>
              </div>
              {/* <span className="text-base-primary">Phone Pin</span> */}
              <div className="email-field">
                <div className="email-field-row">
                  <GuiTextbox
                    label="Phone Pin"
                    name="phonePin"
                    value={state.phonePin}
                    onChange={handleChange}
                    maxLength={50}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="modal-footer">
          <div className="modal-footer-hr-divider"></div>
          <div className="modal-footer-btns">
            <GuiButton className="cancel-btn" onClick={onClose}>
              Close
            </GuiButton>

            <GuiButton
              className="add-btn"
              onClick={onUpdate}
              disabled={state.isUpdateDisabled}
            >
              Update
            </GuiButton>
          </div>
        </div>
      </>
    </div>
  );
};

export default EditPreferencePopup;
